import React from 'react'
import { ChartInternet } from 'components/chartinternet'
import { ChartDownloadspeed } from 'components/chartdownloadspeed'
import { ChartMusic } from 'components/chartmusic'
import { ChartTelephones } from 'components/charttelephones'
import { ChartTelephoneconnections } from 'components/charttelephoneconnections'
import { ChartStreaming } from 'components/chartstreaming'
import { ChartSocialnetworks } from 'components/chartsocialnetworks'
import { DownloadComparison } from 'components/downloadcomparison'
import { StorageEvolution } from 'components/storageevolution'
import { SectionTitle } from 'components/sectiontitle'

import internetUserGroupsData from '../data/internetusergroups.json'
import musikUserGroupsData from '../data/musikusergroups.json'
import telefonieUserGroupsData from '../data/telefonieUserGroups.json'
import festnetzUserGroupsData from '../data/festnetzUserGroups.json'
import socialUserGroupsData from '../data/socialUserGroups.json'

// parses text content from google sheet
// yarn fetchtextcontent fetches text into ../data/phoneusergroups.json
// change gsheet ID in packages.json
const parseUserGroups = json => {
  return json.data.map(el => {
    return {
      from: el.from,
      to: el.to,
      highlight: new Date(el.highlight),
      highlight_y: el.highlight_y,
      title: el.title,
      txt: el.txt
    }
  })
}
const internetUserGroups = parseUserGroups(internetUserGroupsData)
const musikUserGroups = parseUserGroups(musikUserGroupsData)
const telefonieUserGroups = parseUserGroups(telefonieUserGroupsData)
const festnetzUserGroups = parseUserGroups(festnetzUserGroupsData)
const socialUserGroups = parseUserGroups(socialUserGroupsData)

// get data from usergroup to generate personalized feedback
const getPersonalizedFeedback = (array, birthYear) => {
  return array.filter(val => {
    return birthYear >= val.from && birthYear <= val.to
  })
}

export const Docs = () => {
  return (
    <div>
      <div>
        <SectionTitle
          title='Wie wir telefonieren'
          lead='1993 waren Mobiltelefone auf der Strasse noch ein Hingucker,
                  nur sieben Jahre später besass bereits die Mehrheit der
                  Schweizerinnen und Schweizer ein Gerät.'
          startingPoint1={10}
          startingPoint2={21}
          startingPoint3={14}
          startingPoint4={0}
          startingPoint5={35}
          mp4={require('./components/main/vid/telefonieren.mp4')}
          mp4Mobile={require('./components/main/vid/telefonieren.mp4')}
          webm={require('./components/main/vid/telefonieren.mp4')}
          webmMobile={require('./components/main/vid/telefonieren.mp4')}
          poster={require('./components/main/vid/telefonieren.mp4')}
        />
      </div>

      <div style={{ maxWidth: '1121px', margin: '0 auto' }}>
        <StorageEvolution
          title='Die Entwicklung von Datenträgern'
          subtitle='Ein Untertitel'
        />
      </div>

      <div style={{ maxWidth: '581px', margin: '0 auto' }}>
        <DownloadComparison
          title='Downloadgeschwindigkeiten im Vergleich'
          subtitle='Herunterladen eines 800 MB Spielfilms'
        />
      </div>
      <div style={{ maxWidth: '1121px', margin: '0 auto' }}>
        <h2
          style={{
            fontSize: '2em',
            borderBottom: '1px solid #999',
            margin: '1em 0'
          }}
        >
          Echarts
        </h2>
        <ChartInternet
          data={require('../data/internet.json')}
          title={'Wie sich das Internet in der Schweiz ausbreitete'}
          subtitle={'Anteil der Bevölkerung ab 14 Jahren in Prozent'}
          lineColors={{
            'Internetnutzung mehrmals pro Woche': '#319cd5',
            'mobiler Zugang': '#E03997'
          }}
          userGroups={getPersonalizedFeedback(internetUserGroups, 1981)}
        />
        <ChartDownloadspeed
          data={require('../data/internetanschluesse.json')}
          title={'Wie Schweizer Haushalte vernetzt sind'}
          subtitle={
            'Anteil Internetnutzer nach Anschlussart, in Prozent des Totals'
          }
          lineColors={{
            'schnelle Verbindung': '#E03997',
            'mittlere Verbindung': '#FFCA18',
            'langsame Verbindung': '#319cd5'
          }}
          userGroups={getPersonalizedFeedback(internetUserGroups, 1981)}
        />
        <section className='dark'>
        <ChartMusic
          data={require('../data/musikmarkt.json')}
          title={'Wie Schweizer Musik hören'}
          subtitle={'Verkaufte Einheiten in Millionen'}
          lineColors={{
            CD: '#E03997',
            MC: '#FFCA18',
            LP: '#319cd5'
          }}
          userGroups={getPersonalizedFeedback(musikUserGroups, 1981)}
        />
        <ChartStreaming
          data={require('../data/streaming.json')}
          title={'Streaming als schwacher Trost'}
          subtitle={'Umsatz mit Tonträgern in Millionen Franken'}
          lineColors={{
            Physisch: '#319cd5',
            Downloads: '#FFCA18',
            Streaming: '#E03997'
          }}
          userGroups={getPersonalizedFeedback(internetUserGroups, 1981)}
        />
        
        <ChartTelephones
          data={require('../data/telefonie.json')}
          title={'Wie Schweizer mobil telefonieren'}
          subtitle={'Anteil der Bevölkerung in Prozent'}
          lineColors={{
            Mobilfunkkunden: '#319cd5',
            Smartphones: '#E03997'
          }}
          userGroups={getPersonalizedFeedback(telefonieUserGroups, 1981)}
        />
        <ChartTelephoneconnections
          data={require('../data/telefonanschluesse.json')}
          title={'Festnetztelefonie geht zurück'}
          subtitle={'Anzahl Anschlüsse'}
          lineColors={{
            Publifon: '#319cd5',
            Festnetz: '#FFCA18',
            Glasfaser: '#E03997'
          }}
          userGroups={getPersonalizedFeedback(festnetzUserGroups, 1981)}
        />
        </section>
        <ChartSocialnetworks
          data={require('../data/socialnetworks.json')}
          title={'Soziale Netzwerke'}
          subtitle={'Monatlich aktive Nutzer weltweit, in Millionen'}
          lineColors={{
            Instagram: '#E03997',
            Whatsapp: '#54AF71',
            Twitter: '#00A1CA',
            Facebook: '#1D5F82'
          }}
        />
      </div >
    </div>
  )
}
